import { render } from "./PontosPub.vue?vue&type=template&id=738d0b0e&scoped=true"
import script from "./PontosPub.vue?vue&type=script&lang=js"
export * from "./PontosPub.vue?vue&type=script&lang=js"

import "./PontosPub.vue?vue&type=style&index=0&id=738d0b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738d0b0e"]])

export default __exports__